import { FlatTeamSettingsSchema } from "@redotech/redo-model/flat-team-settings";
import { unaryRpc } from "@redotech/rpc/definition";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const _getPickedSettings = unaryRpc({
  name: "getPickedSettings",
  input: z.object({
    teamId: zExt.objectId(),
    keys: z.partialRecord(z.keyof(FlatTeamSettingsSchema), z.literal(1)),
  }),
  output: z.object({ settings: z.unknown() }),
});
